import React from 'react';
import { useMediaLayout } from 'use-media';
import { Text, Anchor } from '../Text';
import styles from './shipsPage.module.sass';
import { isClient } from '../../utils/isClient';
import { ShipSearchResults } from './ShipSearchResults';
import { ShipsSearch } from './ShipsSearch';

export const ShipsPage = ({
  isMobile,
  popdir,
  isDiscount,
  title,
  cashback,
  isSpecial,
  isVendors,
  description,
  liners
}) => {
  const isWide = useMediaLayout('(max-width: 770px)');
  const isMob = useMediaLayout('(max-width: 500px)');
  const getPhoto = () => {
    if (isWide) {
      return `http://kruiz.online/tablet_popdir${popdir.cover_img}`;
    }
    if (isMob) {
      return `http://kruiz.online/mobile_popdir${popdir.cover_img}`;
    }
    return `http://kruiz.online/${popdir.cover_img}`;
  };
  return (
    <>
      <div>
        {!isDiscount && !isVendors ? (
          popdir && (
            <div>
              <div className={styles.searchPagePopdir}>
                <div className={styles.ground}>
                  <div className={styles.searchPageWrap}>
                    <div className={styles.textBannerPopdir}>
                      <Text bottomGap={12}>
                        <Anchor variant="link-2" href="/popdir">
                          Популярные направления
                        </Anchor>
                      </Text>
                      <Text
                        bottomGap={42}
                        variant="heading-1"
                        component="h1"
                        color="white"
                      >
                        {popdir.caption}
                      </Text>
                      <Text
                        className={styles.textBannerPopdirInside}
                        variant="heading-6"
                        color="white"
                      >
                        {description}
                      </Text>
                      {cashback && cashback}
                    </div>
                    <div className={styles.bannerImg}>
                      <img src={getPhoto()} alt="" loading={'lazy'} />
                    </div>
                  </div>
                </div>
              </div>
            </div>
          )
        ) : (
          <div className={styles.discountBanner}>
            <div className={styles.bannerAll}>
              <div className={styles.bannerAllText}>
                {!isMobile && !isVendors && !cashback && (
                  <Text
                    variant="heading-6"
                    component="h1"
                    color="white"
                    className={styles.headText}
                  >
                    Все скидки и акции от круизных операторов
                  </Text>
                )}
                {isSpecial && (
                  <Text variant="textShadow-2">
                    Все актуальные скидки и акции от круизных операторов
                  </Text>
                )}

                <Text
                  variant={isMobile ? 'heading-2' : 'heading-1'}
                  component="h1"
                  color="white"
                  className={styles.textBanner}
                >
                  {!isVendors
                    ? popdir?.caption
                    : 'Все речные круизы без наценок. Расписание и стоимость'}
                </Text>
                {cashback && cashback}
                {popdir?.discount_conditions && (
                  <Text
                    variant="heading-6"
                    color="white"
                    className={styles.discountConditions}
                  >
                    {popdir.discount_conditions}
                  </Text>
                )}
                {title && (
                  <Text color="white">*цены указаны без учета скидки</Text>
                )}
                {popdir?.vendor_promotions && (
                  <div>
                    <Text color="white" variant="textShadow-2">
                      Выбирайте круизы с выгодой до 50%!
                      <br /> Суммируются акции «Лучшее предложение дня»
                      <br /> до 30% и «Кэшбэк 20%»
                    </Text>
                  </div>
                )}
              </div>
              {!isMobile && (
                <div className={styles.bannerImg}>
                  <img
                    src={`http://kruiz.online/${popdir?.cover_img}`}
                    alt=""
                    loading={'lazy'}
                  />
                </div>
              )}
            </div>
          </div>
        )}
      </div>
      <div className={!isMobile ? styles.search : null}>
        {isClient && (
          <>
            <ShipsSearch liners={liners} />
          </>
        )}
      </div>
      <ShipSearchResults liners={liners} popdir={popdir} isMobile={isMobile} />
    </>
  );
};
